// extracted by mini-css-extract-plugin
export default {"image":"SuccessSaveModal_image__faIF2"};